import { ErrorMessageContents } from '../../helpers/hub'
import { Trade, TicketChanges } from './types'

export const tradeBlotterFetch = () => ({ type: 'tradeBlotter.fetch' } as const)
type TradeBlotterFetchAction = ReturnType<typeof tradeBlotterFetch>

export const tradeBlotterFetchCancel = () =>
  ({ type: 'tradeBlotter.fetchCancel' } as const)
type TradeBlotterFetchCancelAction = ReturnType<typeof tradeBlotterFetchCancel>

export const tradeBlotterFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'tradeBlotter.fetchFail', payload: error, error: true } as const)
export type TradeBlotterFetchFailAction = ReturnType<
  typeof tradeBlotterFetchFail
>

export const tradeBlotterAddTrades = (items: Trade[]) =>
  ({ type: 'tradeBlotter.addTrades', payload: items } as const)
export type TradeBlotterAddTradesAction = ReturnType<
  typeof tradeBlotterAddTrades
>

export const confirmTrade = (tradeId: number) =>
  ({
    type: `tradeBlotter.confirmTrade`,
    payload: tradeId
  } as const)
export type ConfirmTradeAction = ReturnType<typeof confirmTrade>

export const checkoutTicket = (ticketId: number, changes: TicketChanges) =>
  ({
    type: `tradeBlotter.checkoutTicket`,
    payload: { ticketId, changes }
  } as const)
export type CheckoutTicketAction = ReturnType<typeof checkoutTicket>

export const uncheckoutTicket = (ticketId: number) =>
  ({
    type: `tradeBlotter.uncheckoutTicket`,
    payload: ticketId
  } as const)
export type UncheckoutTicketAction = ReturnType<typeof uncheckoutTicket>

export const ticketCheckoutSuccess = () =>
  ({ type: `tradeBlotter.ticketCheckoutSuccess` } as const)
type TicketCheckoutSuccessAction = ReturnType<typeof ticketCheckoutSuccess>

export const ticketCheckoutFailure = (error: ErrorMessageContents) =>
  ({
    type: `tradeBlotter.ticketCheckoutFailure`,
    payload: error,
    error: true
  } as const)
type TicketCheckoutFailureAction = ReturnType<typeof ticketCheckoutFailure>

export type TradeBlotterActions =
  | TradeBlotterFetchAction
  | TradeBlotterFetchCancelAction
  | TradeBlotterFetchFailAction
  | TradeBlotterAddTradesAction
  | ConfirmTradeAction
  | CheckoutTicketAction
  | UncheckoutTicketAction
  | TicketCheckoutSuccessAction
  | TicketCheckoutFailureAction
